import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

 const companyID = JSON.parse(localStorage.getItem('companyID'))

  export const getData = createAsyncThunk('repeatbooking/getData', async (params) => {
              
    const response = await axios.post(' https://api.zasway.com:8443/Exclusion/GetTableSummary', params, {mode:'cors'})
      
    return {
      params,
      data: response.data.data,
      allData: response.data.allData,
      totalPages: response.data.total
    }
  })
 
  export const addExclusion = createAsyncThunk('repeatbooking/Create',  async (Exclusion) => {
     
    const response = await axios.post(' https://api.zasway.com:8443/Exclusion/Create', Exclusion, {mode:'cors'})
    
  return response
  })

  export const editExclusion  = createAsyncThunk('repeatbooking/editExclusion', async (Exclusion) => {
     
  const response = await axios.post(' https://api.zasway.com:8443/Exclusion/Update', Exclusion, {mode:'cors'})
  return response
  })

  export const getExclusionTag = createAsyncThunk('repeatbooking/getExclusionTag', async (params) => {
     
  const response = await axios.post(' https://api.zasway.com:8443/Exclusion/GetTableSummary', params, {mode:'cors'})
   
  return {
    params,
    data: response.data.data, 
    allData: response.data.allData,
    totalPages: response.data.total
  }
  })

  export const resetExclusionEditData = createAsyncThunk('repeatbooking/resetExclusionEditData', async () => {
      
    return {data:[]}
  })

  export const getExclusionEditData = createAsyncThunk('repeatbooking/getExclusionEditData', async (params) => {
      
     
    const response = await axios.post(' https://api.zasway.com:8443/Exclusion/GetTableSummary', params, {mode:'cors'})
    return {data:response.data.data}
  })

  export const getRepeatBooking = createAsyncThunk('repeatbooking/getRepeatBooking', async (params) => {
      
     
    const response = await axios.post(' https://api.zasway.com:8443/Booking/GetTableSummaryRepeatBooking', params, {mode:'cors'})
    
    return response.data
  })

  export const cancelRepeatBooking = createAsyncThunk('repeatbooking/cancelRepeatBooking', async (params) => {
      
     
    const response = await axios.post(' https://api.zasway.com:8443/Booking/CancelRepeatBooking', params, {mode:'cors'})
    
    return response.data
  })

  export const EditExclusionTag = createAsyncThunk('repeatbooking/Update', async (Tag, {dispatch}) => {
    const response = await axios.post(' https://api.zasway.com:8443/Exclusion/Update', Tag, {mode:'cors'})
    await dispatch(getData({
        companyID, 
        userID: 0, 
        id: 0, 
        page: 0, 
        perPage: 10
      }))
    return response
  })

  export const deleteExclusion = createAsyncThunk('repeatbooking/Delete', async (id, { dispatch, getState }) => {
     
    const response = await axios.post(' https://api.zasway.com:8443/Exclusion/Delete', id, {mode:'cors'})
      
    await dispatch(getData(getState().repeatBooking.params))
    
    return response
  })

  export const RepeatBookingSlice = createSlice({
        name: 'repeatbooking',
        initialState: {
          data: [],
          total: 1,
          params: {},
          allData: [],
          selectedUser: null,
          exclusionTagEditData: [],
          flightdata: []
        },
      reducers: {},
      extraReducers: builder => {
          builder

      .addCase(getData.fulfilled, (state, action) => {
        
        state.data = action.payload.data
        state.allData = action.payload.allData
        state.total = action.payload.totalPages
        state.params = action.payload.params
      })

      .addCase(getExclusionTag.fulfilled, (state, action) => {
         
        state.data = action.payload.data
        state.params = action.payload.params
        state.allData = action.payload.allData
        state.total = action.payload.totalPages
      })

      // .addCase(searchflight.fulfilled, (state, action) => {
      //    
      //   state.data = action.payload.data
      //   state.params = action.payload.params
      //   state.allData = action.payload.allData
      //   state.total = action.payload.totalPages
      // })

      .addCase(getExclusionEditData.fulfilled, (state, action) => {
         
        state.exclusionTagEditData = action.payload.data
      })

      .addCase(resetExclusionEditData.fulfilled, (state, action) => {
         
        state.exclusionTagEditData = action.payload.data
      })
    }
  })

export default RepeatBookingSlice.reducer